import { EndpointsName } from './authTypes';

const awsmobile = {
    Auth: {
        identityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID,
        region: process.env.AWS_COGNITO_REGION,
        userPoolId: process.env.AWS_USER_POOLS_ID,
        userPoolWebClientId: process.env.AWS_USER_POOLS_WEB_CLIENT_ID,
        "oauth": {
            "domain": process.env.AWS_OAUTH_DOMAIN,
            "scope": [process.env.AWS_OAUTH_SCOPE_EMAIL, process.env.AWS_OAUTH_SCOPE_PROFILE, process.env.AWS_OAUTH_SCOPE_OPENID],
            "redirectSignIn": process.env.AWS_OAUTH_REDIRECT_SIGN_IN,
            "redirectSignOut": process.env.AWS_OAUTH_REDIRECT_SIGN_OUT,
            "responseType": process.env.AWS_OAUTH_RESPONSE_TYPE
        },
    },
    Storage: {
        AWSS3: {
            bucket: process.env.AWS_S3_BUCKET_NAME,
            region: process.env.AWS_COGNITO_REGION
        }
    }
};

export const endpoints = {
    [EndpointsName.CONFIG]: process.env.REACT_APP_BE_CONFIG_SERVICE_CONFIG_ENDPOINT,
    [EndpointsName.LIMITS]: process.env.REACT_APP_BE_CONFIG_SERVICE_LIMITS_ENDPOINT,
    [EndpointsName.HINTS]: process.env.REACT_APP_BE_CONFIG_SERVICE_HINTS_ENDPOINT,
    [EndpointsName.BBF]: process.env.REACT_APP_BE_BACKEND_FOR_FRONTEND_ENDPOINT,
    [EndpointsName.GLOBAL]: process.env.REACT_APP_BE_CONFIG_SERVICE_GLOBAL_ENDPOINT,
    [EndpointsName.MAINTENANCE]: process.env.REACT_APP_BE_CONFIG_SERVICE_MAINTENANCE_ENDPOINT,
    [EndpointsName.HISTORICAL]: process.env.REACT_APP_BE_CONFIG_SERVICE_HISTORICAL_ENDPOINT,

};
export default awsmobile